// extracted by mini-css-extract-plugin
export default {"primaryBlue":"#00a2d2","primaryLightGrey":"#d1d1d1","carousel_wrapper":"Carousel_carousel_wrapper__VbTgC"};